import service from '@/services/cliente/cliente'

const getDefaultState = () => ({
  cron: {
    emisor: '',
    ciclos: [
      {
        nombre: 'En Contacto',
        valor: 0
      },
      {
        nombre: 'Fidelizacion',
        valor: 0,
        meses: null
      },
      {
        nombre: 'Retencion',
        valor: 0
      },
      {
        nombre: 'Recuperacion',
        valor: 0
      },
      {
        nombre: 'Finalizado',
        valor: 0
      }
    ]
  },
  saved: false
})

export const state = () => getDefaultState()

export const mutations = {
  SET: (state, obj) => {
    state.cron = obj
  },
  RESET_STATE: state => {
    state.cron = { ...getDefaultState().cron }
  },
  SAVE_CHANGES: (state, obj) => {
    state.cron = obj
    state.saved = false
  }
}
export const actions = {
  readCron: async ({ rootGetters, commit }) => {
    return service.readCron(await rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      if (response) commit('SET', response)
      else commit('RESET')

      return response
    })
  },

  create: async ({ rootGetters, state }) => {
    const cron = {
      emisor: { _id: await rootGetters['facturacion/emisorStore/get_Id'] },
      ciclos: state.cron.ciclos.map(c => ({
        nombre: c.nombre,
        valor: Number(c.valor)
      }))
    }

    return service.createCron(cron)
  }
}
